import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "mb-12" }
const _hoisted_3 = { class: "container py-5." }
const _hoisted_4 = { style: {"width":"100%","padding-bottom":"5px"} }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { class: "col-auto" }
const _hoisted_10 = { class: "messaging" }
const _hoisted_11 = { class: "inbox_msg" }
const _hoisted_12 = { class: "mesgs" }
const _hoisted_13 = { class: "msg_history" }
const _hoisted_14 = {
  key: 0,
  style: {"text-align":"center","padding-top":"10px","font-size":"14px","cursor":"pointer","text-decoration":"underline"}
}
const _hoisted_15 = {
  key: 0,
  class: "incoming_msg_img"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "time_date" }
const _hoisted_18 = { style: {"float":"right","margin-right":"5px"} }
const _hoisted_19 = {
  key: 0,
  class: "type_msg"
}
const _hoisted_20 = { class: "input_msg_write" }
const _hoisted_21 = { class: "selected-file-item" }
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_vue_loading = _resolveComponent("vue-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Уведомление", -1)),
      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_el_table, {
        data: _ctx.items,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "#",
            width: "50"
          }),
          _createVNode(_component_el_table_column, { label: "БИН" }, {
            default: _withCtx((scope) => [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.openNotificationModal(scope.row)),
                href: "#"
              }, _toDisplayString(scope.row.bin), 9, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Название ДО" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.kindergartenName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "LMS ID" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.lmsId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Населенный пункт" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getKatoNameRu(scope.row.katoCode)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Адрес" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.address), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Статус" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getLastMessageStatusText(scope.row.lastMessageStatus)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Финансирование" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getFundingStatusText(scope.row.fundingStatus)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Исполнитель" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.fundingStatusSuspendedByUser), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showModal) = $event)),
      title: _ctx.messageModalTitle,
      size: "xl"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_b_button, {
          variant: "secondary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModal = false))
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode("Закрыть")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_2, [
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[14] || (_cache[14] = _createElementVNode("b", { class: "padding-r-5px" }, "Населенный пункт:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getKatoNameRu(_ctx.lmsSystemNotificationDto?.katoCode)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[15] || (_cache[15] = _createElementVNode("b", { class: "padding-r-5px" }, "Адрес:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.lmsSystemNotificationDto?.address), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[16] || (_cache[16] = _createElementVNode("b", { class: "padding-r-5px" }, "Финансирование:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getFundingStatusText(_ctx.lmsSystemNotificationDto?.fundingStatus)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[17] || (_cache[17] = _createElementVNode("b", { class: "padding-r-5px" }, "Контакты:", -1)),
                    (_ctx.lmsSystemNotificationDto?.id)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lmsSystemNotificationDto.directorPhone) = $event)),
                          placeholder: "+7(777)777-7777"
                        }, null, 512)), [
                          [_vModelText, _ctx.lmsSystemNotificationDto.directorPhone]
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updatePhone && _ctx.updatePhone(...args))),
                      class: "btn btn-sm btn-success",
                      style: {"margin-top":"-5px","margin-left":"5px"}
                    }, "Сохранить")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.messages.length && _ctx.messages[0].totalRowCounts > _ctx.messages.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("a", {
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadOldMessages && _ctx.loadOldMessages(...args)))
                            }, "<<Загрузить старые сообщение >>")
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(item.sendByManager ? 'incoming_msg' : 'outgoing_msg')
                        }, [
                          (item.sendByManager)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[18] || (_cache[18] = [
                                _createElementVNode("img", {
                                  src: "https://ptetutorials.com/images/user-profile.png",
                                  alt: "sunil"
                                }, null, -1)
                              ])))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(item.sendByManager ? 'received_msg' : 'sent_msg')
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(item.sendByManager ? 'received_withd_msg' : '')
                            }, [
                              _createElementVNode("p", null, _toDisplayString(item.message), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileDtos, (file) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.downloadFile(file)),
                                    style: {"font-size":"10px"}
                                  }, _toDisplayString(file.fileName) + " (" + _toDisplayString((file.size / 1024).toFixed(2)) + "Kb)", 9, _hoisted_16)
                                ]))
                              }), 256)),
                              _createElementVNode("span", _hoisted_17, [
                                _createTextVNode(_toDisplayString(item.createdAt) + " | " + _toDisplayString(item.createdByFullName) + " ", 1),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getLastMessageStatusText(item.status)), 1)
                              ])
                            ], 2)
                          ], 2)
                        ], 2))
                      }), 256))
                    ]),
                    (_ctx.lmsSystemNotificationDto?.notificationStatus == 'OPEN')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.messageDto) = $event)),
                              class: "write_msg",
                              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.messageDto.trim() && _ctx.sendMessage()), ["enter"])),
                              onKeypress: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                              placeholder: "Введите текст сообщение"
                            }, null, 544), [
                              [_vModelText, _ctx.messageDto]
                            ]),
                            _createElementVNode("button", {
                              class: "msg_send_btn",
                              type: "button",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendMessage()))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-paper-plane'] })
                            ]),
                            _createElementVNode("button", {
                              class: "upload_send_btn",
                              type: "button",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-upload'] })
                            ]),
                            _createElementVNode("input", {
                              type: "file",
                              id: "fileUpload",
                              ref: "fileInput",
                              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                              multiple: "",
                              style: {"display":"none"},
                              accept: ".pdf, .doc, .docx, .xls, .xlsx",
                              class: "form-control"
                            }, null, 544)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageSelectedFiles, (file, index) => {
                              return (_openBlock(), _createElementBlock("span", { key: index }, [
                                _createTextVNode(_toDisplayString(index + 1) + ") " + _toDisplayString(file.name) + " ", 1),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.removeFile(index))
                                }, "❌", 8, _hoisted_22)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_vue_loading, {
      active: _ctx.isLoading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}